import { createTheme } from '@mui/material/styles';
import { blue } from '@mui/material/colors';

// or
const theme = createTheme({
    palette: {
        primary: {
            main: blue[700]
        },
        info: {
            main: "#5bc0de",
            light: "#46b8da",
            dark: "#00a5d6",
        }
    },
    typography: {
        body1: {
            fontSize: "1em"
        },
        "fontFamily": `"Kanit"`,
    },
    components: {
        MuiUseMediaQuery: {
            defaultProps: {
                noSsr: true,
            },
        },
        MuiAppBar: {
            styleOverrides: {
                colorPrimary: {
                    backgroundColor: "transparent"
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: "#000000",
                        // backgroundColor: "#dcdcdc80"
                    },
                },
                // MuiOutlinedInput : {
                //     '&.Mui-disabled': {
                //         color: "#000000",
                //     },
                // }
            }
        },
        MuiInputLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: "#000000",
                    },
                },
                shrink: {
                    top: "0px",
                    background: "#ffffff !important",
                    // background: "transparent !important", //Cosmetic line
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    boxShadow:'12px 12px 26px #e3e3e3, -12px -3px 26px #ffffff'
                }
            }
        },
        // MuiAutocomplete: {
        //     styleOverrides: {
        //         root: {
        //             transform: 'translate3d(0px, 0px, 0px)'
        //         }
        //     }
        // },
        // MuiInputLabel:{
        //     styleOverrides: {
        //         root: {
        //                 '&.Mui-disabled': {
        //                     color: "#000000",
        //                 },
        //         },
        //     },
        // },
        MuiFormLabel: {
            styleOverrides: {
                root: {
                    '&.Mui-disabled': {
                        color: "#000000",
                        // "-webkit-text-fill-color": "#000000"
                    },
                }
            },
        },
        MuiOutlinedInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "white",


                    '&.Mui-disabled': {
                        color: "#000000",
                        backgroundColor: "#f1f1f1"
                    },
                    '&.Mui-MuiInputLabel': {
                        color: "#000000",
                    },
                },
                input: {
                    backgroundColor: "white",
                    '&.Mui-disabled': {
                        color: "#000000",
                        "WebkitTextFillColor": "#000000"
                        // WebkitTextFillColor
                        //-webkit-text-fill-color
                    },
                    '&.Mui-MuiInputLabel': {
                        color: "#000000",
                        "WebkitTextFillColor": "#000000"
                    },
                }
            },
        },
        // MuiTextField: {
        //     styleOverrides: {
        //         root: {
        //             backgroundColor: "white",
        //             '&.Mui-disabled': {
        //                 color: "#000000",
        //             },
        //             '&.Mui-MuiInputLabel': {
        //                 color: "#000000",
        //             },
        //         },
        //     }
        // },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    '&.Mui-disabled': {
                        color: "#000000",
                    },
                },
            }
        }

    },
    breakpoints: {
        values: {
            xs: 0,
            sm: 600,
            md: 900,
            lg: 1200,
            xl: 1536
        }
    }
});
export default theme;